import { en } from './en';
import { zh } from './zh';

export const translations = {
  en,
  zh
};

export const getTranslation = (language) => {
  return translations[language] || translations.en;
};
